export const StarIcon = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.6294 0.291288C10.7318 -0.0298118 11.2682 -0.0298113 11.3706 0.291289C11.9231 2.02495 13.1056 5.10564 15 7C16.8604 8.86041 19.865 10.0343 21.6142 10.5991C21.9401 10.7044 21.9337 11.2708 21.6062 11.371C19.8982 11.8938 16.9871 13.0129 15 15C12.9876 17.0124 11.8655 19.9725 11.3514 21.6708C11.2532 21.9951 10.7069 22.0047 10.6 21.6831C10.0125 19.9147 8.78862 16.7886 7 15C5.18085 13.1809 1.97823 11.9458 0.227598 11.3704C-0.0891653 11.2663 -0.0845961 10.7483 0.233333 10.6478C1.95553 10.1034 5.08434 8.91566 7 7C8.89437 5.10563 10.0769 2.02495 10.6294 0.291288Z"
      fill="url(#paint0_linear_3958_25365)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3958_25365"
        x1="11"
        y1="-0.999999"
        x2="11"
        y2="23"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#96C5FF" />
        <stop offset="1" stopColor="white" />
      </linearGradient>
    </defs>
  </svg>
);
